import { PropsWithChildren, useEffect, useState } from 'react';
import { createSafeContext } from '@mews/framework';

interface PreviousUrlContextProps {
    previousUrl?: string;
    setPreviousUrl: (url: string) => void;
}

const { PreviousUrlContextProvider, usePreviousUrlContext } = createSafeContext<
    'PreviousUrlContext',
    PreviousUrlContextProps
>('PreviousUrlContext');

export const usePreviousUrl = (currentUrl: string) => {
    const { previousUrl, setPreviousUrl } = usePreviousUrlContext();

    useEffect(() => {
        setPreviousUrl(currentUrl);
    }, [currentUrl, setPreviousUrl]);

    return previousUrl;
};

export const PreviousUrlProvider = ({ children }: PropsWithChildren<{}>) => {
    const [previousUrl, setPreviousUrl] = useState<string>();
    return <PreviousUrlContextProvider value={{ previousUrl, setPreviousUrl }}>{children}</PreviousUrlContextProvider>;
};
